import request from '../utils/request';

export function saveCategory(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/category',
            method: 'POST',
            data
        })
    }

    return request({
        url: '/admin/category/'+id,
        method: 'PUT',
        data
    })
}


export function getCategoryList(param) {
    return request({
        url: '/admin/search-category',
        method: 'GET',
        params: param
    })
}



export function setCategoryIsValidate(id, isvalidate) {
    return request({
        url: '/admin/category/'+id+'/is-validate/'+isvalidate,
        method: 'PUT'
    })
}

export function delCategory(id) {
    return request({
        url: '/admin/category/'+id,
        method: 'Delete'
    })
}



